import MuiTabPanel, { TabPanelProps } from '@mui/lab/TabPanel';

export type { TabPanelProps };

export const TabPanel = MuiTabPanel;
